import styled from 'styled-components';
import "typeface-montserrat";
import { Link } from 'react-router-dom';

const LinkText = styled(Link)`
    height: 15px;	
    width: 100%;
    color: #788F9B;	
    font-family: Montserrat;	
    font-size: 12px;	
    line-height: 15px;
    display: flex;
    justify-content:flex-end;
`;

export default LinkText;